import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeftDouble32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCaretLeftDouble32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25.207 8.207a1 1 0 0 0-1.414-1.414l-8.5 8.5-.708.707.707.707 8.5 8.5a1 1 0 0 0 1.415-1.414L17.414 16zm-8.5 0a1 1 0 0 0-1.414-1.414l-8.5 8.5-.708.707.708.707 8.5 8.5a1 1 0 0 0 1.414-1.414L8.914 16z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeftDouble32);
